core.constant('accountMeedyTranslationPL', {
  "T": {
    "MEEDY": {

      "SYSTEM": {
        "ERROR": {
          "PASSWORD_POLICY_VIOLATION": "Nowe hasło nie spełnia polityki bezpieczeństwa!",
          "INCORRECT_OLD_PASSWORD": "Podano nieprawidłowe stare hasło!",
          "OFFICE_USER_CAN_ONLY_EDIT_OWN_ENTRIES": "Użytkownik biura moze edytować jedynie swoje wpisy.",
          "ERROR_DURING_ALAB_APPOINTMENT_ORDER": "Wystąpił błąd podczas zlecania badań do ALAB."
        },
        "VALIDATION": {
          "REPEAT_CORRECT_NEW_PASSWORD": "Powtórz poprawne nowe hasło!"
        },
        "MESSAGE": {
        }
      },
      "UI": {
        "MENU": {
          "LOGGED_AS": "Zalogowany jako",
          "ACCOUNT": "Moje konto",
          "LOG_OUT": "Wyloguj"
        },
        "TABBAR": {
          "ACCOUNT": "Konto"
        },
        "BREADCRUMB": {
          "ACCOUNT": {
            "MY_ACCOUNT": "Moje konto",
            "PASSWORD_CHANGE": "Zmiana hasła"
          }
        }
      },
      "DATA": {
        "ACCOUNT": "Konto"
      },
      "ENUM": {
      },
      "MODULE": {
        "TITLE": {
          "MODULE_ACCOUNT": "Moduł konta"
        },
        "ACCOUNT": {
          "MY_ACCOUNT": "Moje konto",
          "PASSWORD_CHANGE": "Zmiana hasła",
          "OLD_PASSWORD": "Stare hasło",
          "NEW_PASSWORD": "Nowe hasło",
          "REPEAT_NEW_PASSWORD": "Powtórz nowe hasło",
          "CHANGE_PASSWORD": "Zmień hasło",
          "PASSWORD_EXPIRED": "Wymagana zmiana hasła",
          "ADD_NEW_PASSWORD" : "Podaj nowe hasło",
          "EXPORT_DATA": "Eksport danych",
          "LAST_DATA_EXPORT": "Ostatni eksport danych",
          "DOWNLOAD": "Pobierz",
          "NEW_EXPORT": "Nowy eksport"
        }
      }
    }
  }
});


